Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
});
window.theme = window.theme || {};
theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();
  function formatMoney(cents, format){
    if(typeof cents === 'string'){
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if(isNaN(number) || number == null){
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').html();
  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty,bannerSlider;

  init = function(options){
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };
    $.extend(settings, options);
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body = $('body');
    isUpdating = false;
    if(!settings.disableAjaxCart && $addToCart.length){
      formOverride();
    }
    adjustCart();
  };
  loadCart = function(){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function(cart){
    if($cartCountSelector){
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(cart.item_count === 0){
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if($cartCostSelector){
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, shop_currency));
    }
  };
  formOverride = function(){
    $formContainer.on('submit', function(evt){
      evt.preventDefault();
      wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
    });
  };
  itemAddedCallback = function(product){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  itemErrorCallback = function(XMLHttpRequest, textStatus){
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    if(!!data.message){
      if(data.status == 422){
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };
  cartUpdateCallback = function(cart){
    updateCountPrice(cart);
    buildCart(cart);
  };
  buildCart = function(cart){
    $cartContainer.empty();
    if(cart.item_count === 0){
      $cartContainer.append('<div class="wf-wrap text-center"><div class="empty_cart_image_cls"><img src="//bookxcess.myshopify.com/cdn/shop/t/3/assets/cart-empty.jpg?v=59525453492682165831655862225" alt="empty_cart_image" alt="empty_cart_image" ></div><h5 class="empty_cart_slide_cls">Your cart is Empty</h5></div>');
                            cartCallback(cart);
      bannerSlider();
      return;
    }
    var items = [], item = {}, data = {}, source = $("#CartTemplate").html(), template = Handlebars.compile(source);
    $.each(cart.items, function(index, cartItem){
      if(cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '');
      } else{
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      if(cartItem.properties !== null){
        $.each(cartItem.properties, function(key, value){
          if(key.charAt(0) === '_' || !value){
            delete cartItem.properties[key];
          }
        });
      }
      item = {
        key: cartItem.key,
        line: index + 1,
        url: cartItem.url,
        id: cartItem.product_id,
        variantid: cartItem.variant_id,
        img: prodImg,
        name: cartItem.product_title,
        handle: cartItem.handle,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, shop_currency),
        final_price: Shopify.formatMoney(cartItem.final_line_price, shop_currency),
        discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
        discounts: cartItem.discounts,
        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
        vendor: cartItem.vendor,
        metaVal: cartItem
      };
      items.push(item);
    });
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
    };
    $cartContainer.append(template(data));
    cartCallback(cart);
    var carttotalval = cart.total_price;


    $('.sb_block .sb_wrap').each(function(e){
      var temp_shiprate = $(this).data('shiprate');
      if(temp_shiprate<carttotalval){
        $(this).find('.after_ship').addClass('active');
        $(this).find('.before_ship').removeClass('active');
      }else{
        $(this).find('.after_ship').removeClass('active');
        $(this).find('.before_ship').addClass('active');
        var shiprate = temp_shiprate-carttotalval;
        var shop_currency_default = $('#shop_currency_val').text();
        console.log(temp_shiprate,carttotalval,'----',Shopify.formatMoney(temp_shiprate, shop_currency_default));
        shiprate = Shopify.formatMoney(shiprate, shop_currency_default);
        $(this).find('.shiprate span').text(shiprate);
      }
    });

    $('.cpls .standard_shipping').each(function(e){
      var temp_shiprate_2 = $(this).data('shiprate');
      if(temp_shiprate_2 < carttotalval){
        $(this).find('.after_ship').addClass('active');
        $(this).find('.before_ship').removeClass('active');
      }else{
        $(this).find('.after_ship').removeClass('active');
        $(this).find('.before_ship').addClass('active');
        var shiprate = temp_shiprate_2-carttotalval;
        var shop_currency_default = $('#shop_currency_val').text();
        shiprate = Shopify.formatMoney(shiprate, shop_currency_default);
        $(this).find('.shiprate span').text(shiprate);
      }
    });

    bannerSlider();
    $(document).on('click','.cb-currency-item',function(e){
      current_currncy = localStorage.getItem("currencyWidget");
      $('.block-cart-header').removeClass('active');
      $('.cart_'+current_currncy).addClass('active');
    });
    conversionBearAutoCurrencyConverter.convertPricesOnPage();
  };

  cartCallback = function(cart){
    $body.trigger('ajaxCart.afterCartLoad', cart);
    wc_theme_source.lib.on_cart_update(cart);
    if(window.Shopify && Shopify.StorefrontExpressButtons){
      Shopify.StorefrontExpressButtons.initialize();
    }
  };
  bannerSlider= function(){
    var current_currncy;
    if(localStorage.getItem("currencyWidget") != null){
      current_currncy = localStorage.getItem("currencyWidget");
      $('.main_banner .main_slideinr').each(function(){
        var country = $(this).data('id');
        if(current_currncy == country){
          $(this).siblings().hide();
          $(this).css('display','flex');
        }
      });
      $('.sale_slider .sale-slide-wrap').each(function(){
        var sale_banner = $(this).data('id');
        if(current_currncy == sale_banner){
          $(this).show();
          $(this).siblings().hide();
        }
      }); 
      $('.block-cart-header').removeClass('active');
      $('.cart_'+current_currncy).addClass('active');
    }else{
      current_currncy = localStorage.getItem("currencyLocation");
      $('.block-cart-header').removeClass('active');
      $('.cart_'+current_currncy).addClass('active');
    }
  }
  adjustCart = function(){
    $body.on('click', '.ajaxcart__qty-adjust', function(){
      if(isUpdating){
        return;
      }
      var $el = $(this), line = $el.data('line'), $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'), qty = parseInt($qtySelector.val());
      var qty = validateQty(qty);
      if($el.hasClass('ajaxcart__qty--plus')){
        qty += 1;
      } else{
        qty -= 1;
        if(qty <= 0) qty = 0;
      }
      if(line){
        updateQuantity(line, qty);
      } else{
        $qtySelector.val(qty);
      }    
    });

    $body.on('click', '.cart_remove_item', function(e){
      e.preventDefault();
      var line = $(this).attr('data-line');
      wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
    });
    $body.on('change', '.ajaxcart__qty-num', function(){
      if(isUpdating){
        return;
      }
      var $el = $(this), line = $el.data('line'), qty = parseInt($el.val().replace(/\D/g, ''));
      var qty = validateQty(qty);
      if(line){
        updateQuantity(line, qty);
      }
    });
    $body.on('submit', 'form.ajaxcart', function(evt){
      if(isUpdating){
        evt.preventDefault();
      }
    });
    $body.on('focus', '.ajaxcart__qty-adjust', function(){
      var $el = $(this);
      setTimeout(function(){
        $el.select();
      }, 50);
    });
    function updateQuantity(line, qty){
      isUpdating = true;
      var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');
      if(qty === 0){
        $row.parent().addClass('is-removed');
      }
      setTimeout(function(){
        wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
      }, 250);
    }
    $(document).on('click','.wn_title',function(e){
      e.preventDefault();      
      if($(this).parents('.widget_nav').find('.footer_nav').is(":visible")){
        $(this).parents('.widget_nav').find('.footer_nav').slideUp();
      }else{
        $('.widget_nav .footer_nav').slideUp();
        $(this).parents('.widget_nav').find('.footer_nav').slideDown();
      }
    });
  };
  adjustCartCallback = function(cart){
    updateCountPrice(cart);
    setTimeout(function(){
      wc_theme_source.lib.get_cart(buildCart);
      isUpdating = false;
    }, 150)
  };
  validateQty = function(qty){
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)){} else{
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart
  };
  return module;
}(ajaxCart || {}, jQuery));

var shop_currency_default = $('#shop_currency_val').text();
function myCartSection() {
  var SideContentHeight = $('.block-cart-header').innerHeight() + $('.block-cart-footer').innerHeight();
  $('#cart_container_id .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
}
jQuery(window).resize(function(){
  myCartSection();
});

var shop_currency = shop_currency_default;
var wc_theme_source = {
  lib:{
    ajax_error: function(error, message){
      var data = eval('('+error.responseText+')');
      if (!!data.message) {
        $('#added_product_popup').find('h3').text(data.description);
        $('#added_product_popup').find('.cart_redirect_btn').hide();
        $('#added_product_popup').show("clip", 500);
      }
    },
    on_cart_update: function(item){
      setTimeout(function(){
        $.ajax({
          url: "/cart",
          type: "GET",
          success: function (o) {
            var r = $.parseHTML(o),
                c = $(r).find(".cp_vendor").text();
            $(r).length > 0 &&
              r != null &&
              r != "" &&
              r != null &&
              $(r)
            .find(".cp_vendor")
            .each(function (n) {
              var i = $(this).text(),
                  l = $(this).attr("data-id");
              $(".items_row").each(function (u) {
                var s = $(this).attr("data-id");
                s == l &&
                  $(this).find("#cd_vandor").text(i);
              });
            });
          },
        }),
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart_qty_cls').html(cart.item_count);
          if(cart.item_count > 0){

            var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
            if($('.items_carts span').hasClass('money')){
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            } else{
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            }
          } else{
            $('.items_carts span').remove();
            $('.items_carts').html("<span class='money'>$0.00</span>");
          }
          setTimeout(function(){            
            myCartSection();
          },1000);
        });
      },100);
      
      
      var ip_information = JSON.parse(localStorage.getItem('ipstack_info'));
      setTimeout(function(e){
//         $('.sb_wrap.active .cart-country,.cd_head_shipping.active .shipping_country').text(ip_information.state_name);
      }, 2000);
      
      
      
      if(item.item_count > 0){
        console.log('Ip setp',ip_information,'-----',ip_information.currency_code);
        if(ip_information.currency_code == 'MYR'){
          if($('.cd_head_shipping,.sb_wrap').hasClass('active')){
            
          }else{
            $('.cd_head_shipping[data-code="MYR"],.sb_wrap[data-code="MYR"]').addClass('active');
          }
        }
        $('.cd_head_shipping.active').show();
      }else{
        $('.cd_head_shipping').hide();
      }
      var cd_height = $('.cd_item').innerHeight() + $('.cd_footer').innerHeight();
      $('.cd_block').css('height', $(window).height() - cd_height + 'px');
    },
    on_item_added: function(item){      
      ajaxCart.load();
    },
    on_product: function(e){
      alert("Received everything we ever wanted to know about " + e.title);
    },
    addtocart_product: function(id, qty, callback){
      console.log('----addtocart_product called- add-to-cart.js.liquid----')
      var qty = qty || 1;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + id,
        dataType: "json",
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, id);
          } else{
            wc_theme_source.lib.on_item_added(item);
          }
          setTimeout(function(){
            $("body").addClass("CartOpen");
          },500);
          jQuery.getJSON('/cart.js', function(cart) {
            $('.cart-count-block').text(cart.item_count);
            $('.cart_item_cls').text(cart.item_count);
            $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
            $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
            conversionBearAutoCurrencyConverter.convertPricesOnPage();
          });
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    get_product: function(handle, callback){
      jQuery.getJSON("/products/" + handle + ".js", function(product, n){
        wc_theme_source.lib.on_product(product);
      });
    },
    get_cart: function(callback){
      jQuery.getJSON("/cart.js", function(cart, textstatus){
        if((typeof callback) === 'function'){
          callback(cart);
        } else{
          wc_theme_source.lib.on_cart_update(cart);
        }
      });
    },
    addtocart_form: function(form_id, callback, errorCallback, this_click){
      var ajax = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery('#' + form_id).serialize(),
        dataType: 'json',
        beforeSend: function(){
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, form_id);
          } else{
            wc_theme_source.lib.on_item_added(item);
          }
          setTimeout(function(){
            $("body").addClass("CartOpen");
          },500);
          setTimeout(function(){
            jQuery.getJSON('/cart.js', function(cart) {
              $('.cart-count-block').text(cart.item_count);
              $('.cart_item_cls').text(cart.item_count);
              $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
              conversionBearAutoCurrencyConverter.convertPricesOnPage();
            });
          }, 500);
        },
        error: function(XMLHttpRequest, textStatus){
          if((typeof errorCallback) === 'function'){
            errorCallback(XMLHttpRequest, textStatus);
          } else{
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
          }
        }
      };
      jQuery.ajax(ajax);
    },
    cart_change_item: function(line, qty, callback){
      var ajax = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&line=' + line,
        dataType: 'json',
        success: function(cart){
          var url = window.location.href;
          $('.mob_cp_container').load(url + ' .mob_cp_container .cart-main-wrap', function(){
            window.history.pushState({}, null, url);  
          });

          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          setTimeout(function(){
            jQuery.getJSON('/cart.js', function(cart) {
              $('.cart-count-block').text(cart.item_count);
              $('.cart_item_cls').text(cart.item_count);
              $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
              conversionBearAutoCurrencyConverter.convertPricesOnPage();
            });
          }, 500);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_remove_item: function(line, callback){
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + line,
        dataType: "json",
        beforeSend: function(){
          jQuery('.cart_loader_cls_id').show();
        },
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          jQuery('.cart_loader_cls_id').hide();
          setTimeout(function(){
            jQuery.getJSON('/cart.js', function(cart){
              $('.cart-count-block').text(cart.item_count);
              $('.cart_item_cls').text(cart.item_count);
              $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
              conversionBearAutoCurrencyConverter.convertPricesOnPage();
            });
          }, 500);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_clear_all: function(){
      var ajax = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    update_cart_form: function(form){
      var ajax = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + form).serialize(),
        dataType: "json",
        beforeSend: function(){
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
          setTimeout(function(){
            jQuery.getJSON('/cart.js', function(cart) {
              $('.cart-count-block').text(cart.item_count);
              $('.cart_item_cls').text(cart.item_count);
              $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
              conversionBearAutoCurrencyConverter.convertPricesOnPage();
            });
          }, 500);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    }
  }
}

jQuery(document).on('click', '.add_to_cart_btn_cls', function(){
  var this_click = $(this).data('click');
  var temp_form_id = jQuery(this).closest('form').attr('id');
  wc_theme_source.lib.addtocart_form(temp_form_id, '', '', this_click);
  $('html, body').animate({
    scrollTop: $(".cart-side-panel").offset().top
  }, 2000);
  return false;
});

jQuery(document).on('click', '.cart_add_btn', function(){
//   $("body").addClass("CartOpen");
  var this_click = $(this).data('click');
  var temp_variant_id = jQuery(this).attr('data-id');
  var temp_qty = 1;
  wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
  $('html, body').animate({
    scrollTop: $(".cart-side-panel").offset().top
  }, 2000);
  return false;
});


$(document).on('click', '.pro_add_to_cart', function(){
//   $("body").addClass("CartOpen");
  var this_click = $(this).data('click');
  var temp_variant_id = jQuery(this).attr('data-id');
  var temp_qty = $(this).parents('.pro_wrap').find('.product-form__quantity .quantity__input').val();
  wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
  $('html, body').animate({
    scrollTop: $(".cart-side-panel").offset().top
  }, 2000);
});


$(document).on('click','.wc_donate_product', function(){
  var id = $(this).data('id');
  var qty = $(this).prev('.donation-make-wish-price').find('.quantity .quantity__input').val();
  var children_name = $(this).data('children-name');
  var data = {
    "Donation": true,
    "Donation Type": "Make A Wish",
    "Donation to": children_name
  }
  $.post('/cart/add.js', {
    items: [
      {
        quantity: qty,
        id: id, 
        properties: data
      }
    ]
  }, function(data){
    $("body").addClass("CartOpen");
    if((typeof callback) === 'function'){
      callback(data, id);
    } else{
      wc_theme_source.lib.on_item_added(data);
    }
    jQuery.getJSON('/cart.js', function(cart) {
      $('.cart-count-block').text(cart.item_count);
      $('.cart_item_cls').text(cart.item_count);
      $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
      $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
      conversionBearAutoCurrencyConverter.convertPricesOnPage();
    });
    $('html, body').animate({
      scrollTop: $(".cart-side-panel").offset().top
    }, 2000); 
    jQuery.post('/cart/update.js', "attributes[Donation Product]=true")
  });
});

$(document).on('click','button.donation_cart_add_btn', function() {
  console.log('donation_cart_add_btn called' );
  $("body").addClass("CartOpen");
  var id = $(this).data('id');
  var qty = $(this).prev('.pro_grid_star').find('.quantity .quantity__input').val();
  var camp_name_isis = $('.donation-product-grid').data('camp_name_isis');
  var data = {
    "Donation": true,
    "Donation Type": "Organization",
    "Donation to": camp_name_isis
  }
  $.post('/cart/add.js', {
    items: [
      {
        quantity: qty,
        id: id, 
        properties: data
      }
    ]
  }, function(data){
    if((typeof callback) === 'function'){
      callback(data, id);
    } else{
      wc_theme_source.lib.on_item_added(data);
    }
    jQuery.getJSON('/cart.js', function(cart) {
      $('.cart-count-block').text(cart.item_count);
      $('.cart_item_cls').text(cart.item_count);
      $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
      $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
      conversionBearAutoCurrencyConverter.convertPricesOnPage();
    });
    $('html, body').animate({
      scrollTop: $(".cart-side-panel").offset().top
    }, 2000); 
    jQuery.post('/cart/update.js', "attributes[Donation Product]=true")
  });
})




$(document).on('click', '.donation_add_cart_btn' ,function(){
  var id = $(this).attr('data-id');
  var camp_name_isis = $(this).parents('.donation-campaign-block').attr('data-camp_name_isis');
  var qty= $(this).parents('.donation-campaign-block').find('.quantity .quantity__input').val();
  var data = {
    "Donation": true,
    "Donation Type": "Organization",
    "Donation to": camp_name_isis
  }
  $.post('/cart/add.js', {
    items: [
      {
        quantity: qty,
        id: id, 
        properties: data
      }
    ]
  }, function(data){
    if((typeof callback) === 'function'){
      callback(data, id);
    } else{
      wc_theme_source.lib.on_item_added(data);
    }
    jQuery.post('/cart/update.js', "attributes[Donation Product]=true").done(function(index,response){
      jQuery.getJSON('/cart.js', function(cart){
        console.log('cart abc',cart);
        $('.cart-count-block').text(cart.item_count);
        $('.cart_item_cls').text(cart.item_count);
        $('.h_cart_total .money').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
        $('.h_cart_total .money').attr('data-amount', cart.original_total_price/100);
        conversionBearAutoCurrencyConverter.convertPricesOnPage();
      });
    });
  });
  var item = $(this).parent('.donate_btn_block').siblings('.quantity').find('.quantity__input').val();
  $(this).next('.donate_item_count').text(item +' item added');
});



jQuery(document).on("click",".predictive-search__item-content .search_cart_Btn",function(e) {
  e.preventDefault();
  var variant_id = $(this).data('id');
  var this_click = $(this).data('click');
  wc_theme_source.lib.addtocart_product(variant_id, 1, '', this_click);
  $('html, body').animate({
    scrollTop: $(".cart-side-panel").offset().top
  }, 2000);
  setTimeout(function(){
    $('button.h_cart_Btn.cartBtn').trigger('click');
    $('input.QuantityInput.Quantity_cart_slider.ajaxcart__qty-num').trigger('focus');
  }, 1000);
  return false;
});


jQuery(document).on('click', '.grid_cart_redirect', function(){   
  var this_click = $(this).data('click');
  var temp_variant_id = jQuery(this).attr('data-id');
  var temp_qty = 1;
  var ajax = {
    type: "POST",
    url: "/cart/add.js",
    data: "quantity=1&id=" + temp_variant_id,
    dataType: "json",
    success: function(item){
      window.location.href = '/cart';
    },
    error: function(XMLHttpRequest, textStatus){
      wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(ajax);

  return false;
});

jQuery(document).ready(function(){
  ajaxCart.load();
});	